export const hnaviAreas = {
  北海道: [{ name: '北海道', code: 'hokkaido' }],
  東北: [
    { name: '青森県', code: 'aomori' },
    { name: '岩手県', code: 'iwate' },
    { name: '秋田県', code: 'akita' },
    { name: '山形県', code: 'yamagata' },
    { name: '宮城県', code: 'miyagi' },
    { name: '福島県', code: 'fukushima' },
  ],
  関東: [
    { name: '東京都', code: 'tokyo' },
    { name: '神奈川県', code: 'kanagawa' },
    { name: '埼玉県', code: 'saitama' },
    { name: '千葉県', code: 'chiba' },
    { name: '茨城県', code: 'ibaraki' },
    { name: '栃木県', code: 'tochigi' },
    { name: '群馬県', code: 'gunma' },
  ],
  '中部・北陸': [
    { name: '愛知県', code: 'aichi' },
    { name: '静岡県', code: 'shizuoka' },
    { name: '岐阜県', code: 'gifu' },
    { name: '三重県', code: 'mie' },
    { name: '山梨県', code: 'yamanashi' },
    { name: '長野県', code: 'nagano' },
    { name: '新潟県', code: 'niigata' },
    { name: '石川県', code: 'ishikawa' },
    { name: '富山県', code: 'toyama' },
    { name: '福井県', code: 'fukui' },
  ],
  関西: [
    { name: '大阪府', code: 'osaka' },
    { name: '兵庫県', code: 'hyogo' },
    { name: '京都府', code: 'kyoto' },
    { name: '奈良県', code: 'nara' },
    { name: '滋賀県', code: 'shiga' },
    { name: '和歌山県', code: 'wakayama' },
  ],
  '中国・四国': [
    { name: '広島県', code: 'hiroshima' },
    { name: '岡山県', code: 'okayama' },
    { name: '山口県', code: 'yamaguchi' },
    { name: '鳥取県', code: 'tottori' },
    { name: '島根県', code: 'shimane' },
    { name: '徳島県', code: 'tokushima' },
    { name: '香川県', code: 'kagawa' },
    { name: '愛媛県', code: 'ehime' },
    { name: '高知県', code: 'kochi' },
  ],
  '九州・沖縄': [
    { name: '福岡県', code: 'fukuoka' },
    { name: '佐賀県', code: 'saga' },
    { name: '長崎県', code: 'nagasaki' },
    { name: '熊本県', code: 'kumamoto' },
    { name: '大分県', code: 'oita' },
    { name: '宮崎県', code: 'miyazaki' },
    { name: '鹿児島県', code: 'kagohsima' },
    { name: '沖縄県', code: 'okinawa' },
  ],
};
